export const defaultSettings = {
  title: '易缆网运营后台',
  logo: 'logo.ico',
  token: {
    key: 'token',
    expires: 30, // 天
  },
}